import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const BackerStatusAndRewards = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const heading = sectionRef.current.querySelector('.status-heading')
    const items = sectionRef.current.querySelectorAll('.status-card')

    // Set initial state
    gsap.set([heading, items], { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 85%',
      once: true,
      onEnter: () => {
        gsap.to(heading, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: 'power3.out',
          onComplete: () => {
            gsap.to(items, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.15,
              ease: 'power3.out'
            })
          }
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="backer-status-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2 className="status-heading">Backer Status and Rewards</h2>

        <div className="status-card">
          <h4 className="status-title">Status Levels</h4>
          <p className="status-desc">
            Backers are assigned one of four status levels, represented by different colored Orca Badges.
          </p>
        </div>

        <div className="status-card">
          <h4 className="status-title">Earning Ranks</h4>
          <p className="status-desc">
            Status and ranks are earned through efforts defined by Founders (e.g., promotional activities).
          </p>
        </div>

        <div className="status-card">
          <h4 className="status-title">Tracking Earnings</h4>
          <p className="status-desc">
            Backers can view their earnings and claims in USDC through a transparent record.
          </p>
        </div>

        <div className="status-card">
          <h4 className="status-title">More Coming</h4>
          <p className="status-desc">
            Future reward mechanisms will further expand backer benefits and tracking systems.
          </p>
        </div>
      </div>
    </section>
  )
}

export default BackerStatusAndRewards
